import React from 'react'
import PropTypes from 'prop-types'
import { JsonLd } from 'react-schemaorg'
import { menuTreeFromPages } from '@helpers/menuHelpers'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { useStaticQuery, graphql } from 'gatsby'
import Headroom from 'react-headroom'
import { Header, Footer, Drilldown } from '@components'
import ThemeContext from '@context/themeContext'

const Layout = ({ children, pageType = '' }) => {
  const { site, allSitePage } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          lang
          siteUrl
        }
      }

      allSitePage {
        nodes {
          ...MenuHelpersAllPages
        }
      }
    }
  `)

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.siteMetadata.title,
    description: site.siteMetadata.description,
    email: site.siteMetadata.email,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        email: site.siteMetadata.email,
        contactType: 'customer service'
      }
    ],
    url: site.siteMetadata.siteUrl,
    logo: site.siteMetadata.logo,
    sameAs: [
      site.siteMetadata.dedikate,
      site.siteMetadata.facebook,
      site.siteMetadata.instagram
    ]
  }

  const menuItems = menuTreeFromPages(allSitePage.nodes)

  const classes = ['layout']

  return (
    <>
      <HelmetDatoCms defer={false}>
        <meta name="format-detection" content="telephone=no" />
        <html lang="en" />
      </HelmetDatoCms>
      <ThemeContext.Consumer>
        {({ isSidebarOpen, closeSidebar }) => {
          return (
            <div id="layout" className={classes.join(' ')}>
              <Headroom disableInlineStyles>
                <Header
                  menuItems={menuItems}
                  lowOpacity={pageType === 'index'}
                />
              </Headroom>
              <div className={'layout__content'}>
                <main>{children}</main>
              </div>
              <Footer />
              {isSidebarOpen && (
                <div className={'layout__sidebar'}>
                  <Drilldown
                    isVisible={isSidebarOpen}
                    items={menuItems}
                    closeSidebar={closeSidebar}
                  />
                </div>
              )}
              <JsonLd item={schema} />
            </div>
          )
        }}
      </ThemeContext.Consumer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
